import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { BrandLogo } from '../components/BrandLogo';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      toast.error('Errore nella richiesta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16" data-testid="forgot-page">
      <div className="w-full max-w-md surface p-7 sm:p-8">
        <BrandLogo compact className="mb-5" />
        <h1 className="font-display text-2xl font-bold text-brand-dark mb-2">Recupera password</h1>
        {sent ? (
          <p className="text-sm text-slate-600" data-testid="forgot-sent">
            Se l'email è registrata, riceverai a breve un link per impostare una nuova password (valido 1 ora).
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-500">Inserisci l'email del tuo account.</p>
            <div>
              <Label htmlFor="femail">Email</Label>
              <Input id="femail" type="email" required className="h-12 mt-1.5" data-testid="forgot-email"
                value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full h-12 rounded-full bg-brand hover:bg-brand-hover text-white font-semibold">
              {loading ? 'Invio...' : 'Invia link di ripristino'}
            </Button>
          </form>
        )}
        <p className="text-sm text-slate-500 mt-5"><Link to="/accedi" className="text-brand font-semibold">← Torna al login</Link></p>
      </div>
    </div>
  );
}

export function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      toast.success('Password aggiornata. Accedi con la nuova password.');
      navigate('/accedi');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Link non valido o scaduto');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16" data-testid="reset-page">
      <div className="w-full max-w-md surface p-7 sm:p-8">
        <BrandLogo compact className="mb-5" />
        <h1 className="font-display text-2xl font-bold text-brand-dark mb-2">Nuova password</h1>
        {!token ? (
          <p className="text-sm text-rose-600">Link non valido: token mancante.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="npassword">Nuova password</Label>
              <Input id="npassword" type="password" required minLength={8} className="h-12 mt-1.5" data-testid="reset-password-input"
                value={password} onChange={(e) => setPassword(e.target.value)} />
              <p className="text-xs text-slate-400 mt-1.5">Minimo 8 caratteri. Tutti i dispositivi verranno disconnessi.</p>
            </div>
            <Button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full h-12 rounded-full bg-brand hover:bg-brand-hover text-white font-semibold">
              {loading ? 'Salvataggio...' : 'Imposta password'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
